import CONFIG from "../config";
import { contextPath } from "../utils/functions";

export default (props) => {
  const mandantId = String(localStorage.getItem("mandantIdLink")).match(/^[a-z0-9]+$/i)
    ? "?mandant=" + String(localStorage.getItem("mandantIdLink"))
    : "null";
  return (
    <div>
      {props.children}
      <ul aria-label="Liste der Shops">
        <li aria-label={CONFIG.NOBLEMETALS_SHOP_BUY_TITLE}>
          <a target="_self" href={contextPath(CONFIG.NOBLEMETALS_SHOP_BUY) + mandantId}>
            {CONFIG.NOBLEMETALS_SHOP_BUY_TITLE}
          </a>
        </li>
        <li aria-label={CONFIG.NOBLEMETALS_SHOP_SELL_TITLE}>
          <a target="_self" href={contextPath(CONFIG.NOBLEMETALS_SHOP_SELL) + mandantId}>
            {CONFIG.NOBLEMETALS_SHOP_SELL_TITLE}
          </a>
        </li>
        <li aria-label={CONFIG.CURRENCIES_SHOP_BUY_TITLE}>
          <a target="_self" href={contextPath(CONFIG.CURRENCIES_SHOP_BUY) + mandantId}>
            {CONFIG.CURRENCIES_SHOP_BUY_TITLE}
          </a>
        </li>
        <li aria-label={CONFIG.CURRENCIES_SHOP_SELL_TITLE}>
          <a target="_self" href={contextPath(CONFIG.CURRENCIES_SHOP_SELL) + mandantId}>
            {CONFIG.CURRENCIES_SHOP_SELL_TITLE}
          </a>
        </li>
        <li aria-label="Verwaltungsfunktionen">
          <a target="_self" href={contextPath(String(CONFIG.CONTEXT_ROOT) + String(CONFIG.LINK_ADMIN_PAGE))}>
            Verwaltungsfunktionen
          </a>
        </li>
      </ul>
    </div>
  );
};
